import { Link } from '@tanstack/react-router';
import { ChevronDown, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import { useWorkspaceNavigation } from './use-workspace-navigation';

export function AppHeaderNavigation() {
  const { tenantId, featured, overview, groups, label, isActive } =
    useWorkspaceNavigation();

  return (
    <div className="flex min-w-0 items-center gap-1">
      <SidebarTrigger className="md:hidden" />
      <nav
        className="hidden min-w-0 items-center gap-1 md:flex"
        aria-label="Workspace"
      >
        {featured ? (
          <Button
            nativeButton={false}
            variant="ghost"
            size="sm"
            className={cn(isActive(featured) && 'bg-muted text-foreground')}
            render={
              <Link to={featured.to.replace('$tenantId', tenantId) as never} />
            }
          >
            <featured.icon aria-hidden="true" />
            {label(featured)}
          </Button>
        ) : null}
        {overview ? (
          <Button
            nativeButton={false}
            variant="ghost"
            size="sm"
            className={cn(isActive(overview) && 'bg-muted text-foreground')}
            render={
              <Link to={overview.to.replace('$tenantId', tenantId) as never} />
            }
          >
            <overview.icon aria-hidden="true" />
            {label(overview)}
          </Button>
        ) : null}
        {groups.map((group) => (
          <DropdownMenu key={group.key}>
            <DropdownMenuTrigger
              render={
                <Button
                  variant="ghost"
                  size="sm"
                  className={cn(group.active && 'bg-muted text-foreground')}
                />
              }
            >
              {group.label}
              <ChevronDown className="size-3.5" aria-hidden="true" />
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="min-w-52"
              align="start"
              sideOffset={7}
            >
              {group.items.map((item) => {
                const Icon = item.icon;
                return (
                  <DropdownMenuItem
                    key={item.routeId}
                    className={cn(
                      'min-h-9',
                      isActive(item) && 'bg-accent font-medium',
                    )}
                    render={
                      <Link
                        to={item.to.replace('$tenantId', tenantId) as never}
                      />
                    }
                  >
                    <Icon aria-hidden="true" />
                    {label(item)}
                  </DropdownMenuItem>
                );
              })}
            </DropdownMenuContent>
          </DropdownMenu>
        ))}
      </nav>
      <Menu
        className="ml-1 hidden size-4 text-muted-foreground max-md:block"
        aria-hidden="true"
      />
    </div>
  );
}
